import { useState } from "react";
import { getClient } from "./platformAdminProvider";
import { validatePasswordChange } from "./passwordValidation";

export function PasswordChangeForm({
  email,
}: {
  email: string | undefined;
}) {
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const validationError = validatePasswordChange(password, confirmation);
    if (validationError) {
      setMessage(validationError);
      return;
    }

    setBusy(true);
    setMessage("");
    try {
      const { error } = await getClient().auth.updateUser({ password });
      if (error) throw error;
      setPassword("");
      setConfirmation("");
      setMessage("密码已更新，请重新登录以确认新密码");
    } catch (cause) {
      setMessage(cause instanceof Error ? cause.message : "密码更新失败，请重试");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-4 max-w-2xl rounded-xl border bg-white p-5">
      <h3 className="text-lg font-semibold">管理员账号安全</h3>
      <p className="mt-1 text-sm text-slate-500">
        修改当前管理员密码。密码只交给 Supabase Auth 处理，不会写入平台数据表。
      </p>
      <form className="mt-4 grid gap-3" onSubmit={submit}>
        <label className="text-sm font-medium">
          当前管理员邮箱
          <input
            className="mt-2 w-full rounded-lg border bg-slate-50 px-3 py-2 text-sm text-slate-600"
            value={email ?? ""}
            readOnly
          />
        </label>
        <label className="text-sm font-medium">
          新密码
          <input
            className="mt-2 w-full rounded-lg border px-3 py-2"
            type="password"
            value={password}
            autoComplete="new-password"
            onChange={(event) => setPassword(event.target.value)}
            required
          />
        </label>
        <label className="text-sm font-medium">
          确认新密码
          <input
            className="mt-2 w-full rounded-lg border px-3 py-2"
            type="password"
            value={confirmation}
            autoComplete="new-password"
            onChange={(event) => setConfirmation(event.target.value)}
            required
          />
        </label>
        {message && <p className="text-sm text-slate-600">{message}</p>}
        <button
          className="w-fit rounded-lg bg-teal-700 px-4 py-2 text-sm text-white disabled:opacity-50"
          type="submit"
          disabled={busy}
        >
          {busy ? "更新中……" : "更新密码"}
        </button>
      </form>
    </div>
  );
}
